/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Range_Past_MonthInputs */

const en_date_range_past_month = /** @type {(inputs: Date_Range_Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Month`)
};

const fr_date_range_past_month = /** @type {(inputs: Date_Range_Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mois passé`)
};

const de_date_range_past_month = /** @type {(inputs: Date_Range_Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzter Monat`)
};

const it_date_range_past_month = /** @type {(inputs: Date_Range_Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mese scorso`)
};

const ru_date_range_past_month = /** @type {(inputs: Date_Range_Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прошлый месяц`)
};

const es_date_range_past_month = /** @type {(inputs: Date_Range_Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El mes pasado`)
};

const zh_cn2_date_range_past_month = /** @type {(inputs: Date_Range_Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上个月`)
};

const ja_date_range_past_month = /** @type {(inputs: Date_Range_Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先月`)
};

const hi_date_range_past_month = /** @type {(inputs: Date_Range_Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बीते हुए महीने में`)
};

const pt_pt2_date_range_past_month = /** @type {(inputs: Date_Range_Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mês passado`)
};

/**
* | output |
* | --- |
* | "Past Month" |
*
* @param {Date_Range_Past_MonthInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const date_range_past_month = /** @type {((inputs?: Date_Range_Past_MonthInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Range_Past_MonthInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_date_range_past_month(inputs)
	if (locale === "de") return de_date_range_past_month(inputs)
	if (locale === "it") return it_date_range_past_month(inputs)
	if (locale === "ru") return ru_date_range_past_month(inputs)
	if (locale === "es") return es_date_range_past_month(inputs)
	if (locale === "zh-CN") return zh_cn2_date_range_past_month(inputs)
	if (locale === "ja") return ja_date_range_past_month(inputs)
	if (locale === "hi") return hi_date_range_past_month(inputs)
	if (locale === "pt-PT") return pt_pt2_date_range_past_month(inputs)
	return en_date_range_past_month(inputs)
});